/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from "react";

import "./Progress.scss";

interface ProgressProps {
	value: number;
	className?: string;
	total?: number;
	color?: string;
}
const Progress: FC<ProgressProps> = ({
	value,
	total = 100,
	className = "",
	color = "primary_300",
}) => (
	<div className={`${className} h_xxs w_100_per bg_neutral_300`}>
		<div
			className={`h_100_per bg_${color}`}
			style={{ width: `${(value * 100) / total}%` }}
		/>
	</div>
);

export default Progress;
